// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from "react-responsive-carousel";
// import "./carouseledit.css";

// const BannerOne = () => {
//   const [banners, setBanners] = useState([]);

//   useEffect(() => {
//     const fetchBanner = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}/banner`);
//         if (res.data && Array.isArray(res.data)) {
//           const activeBanners = res.data.filter((b) => b.status);
//           setBanners(activeBanners);
//         }
//       } catch (err) {
//         console.error("Error fetching banners:", err);
//       }
//     };
//     fetchBanner();
//   }, []);

//   return (
//     <>
//       <style>{`
//         /* Responsive Banner Styling */
//         .banner-item {
//           height: 500px;
//         }

//         @media (max-width: 991px) {
//           .banner-item {
//             height: 300px !important;
//             border-radius: 16px !important;
//           }

//           .banner-item img {
//             object-fit: cover !important;
//             height: 100% !important;
//           }

//           .scroll-down {
//             width: 60px !important;
//             height: 60px !important;
//             font-size: 18px !important;
//             bottom: 10px !important;
//           }
//         }
//         @media (max-width: 991px) {
//           .desktop-only {
//             display: none !important;
//           }
//         }

//         @media (max-width: 575px) {
//           .banner-item {
//             height: 220px !important;
//           }

//           .scroll-down {
//             width: 48px !important;
//             height: 48px !important;
//             font-size: 16px !important;
//           }
//         }
//       `}</style>

//       <div className="banner">
//         <div className="container container-lg">
//           <div
//             className="banner-item rounded-24 overflow-hidden position-relative"
//             style={{ height: "500px" }}
//           >
//             {/* Scroll Down Icon */}
//             <a
//               href="#flashSaleToday"
//               className="desktop-only scroll-down w-84 h-84 text-center flex-center bg-main-600 rounded-circle border border-5 text-white border-white position-absolute start-50 translate-middle-x bottom-0 hover-bg-main-800"
//               style={{ zIndex: 10 }}
//             >
//               <span className="icon line-height-0">
//                 <i className="ph ph-caret-double-down" />
//               </span>
//             </a>

//           <Carousel
//             autoFocus={true}
//             showArrows={true}
//             autoPlay={true}
//             infiniteLoop={true}
//             interval={4000}
//             transitionTime={400}
//             showStatus={false}
//             showThumbs={false}
//             swipeable={true}
//             emulateTouch={true}
//             style={{ height: '100%' }}
//           >
//             {banners.map((item, index) => (
//               <div key={index} style={{ height: '500px' }}>
//                 <Link to={item.link} style={{ display: 'block', height: '100%' }}>
//                   <img
//                     src={item.banner}
//                     alt={`Banner ${index + 1}`}
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover',
//                       display: 'block',
//                     }}
//                   />
//                 </Link>
//               </div>
//             ))}
//           </Carousel>
//         </div>
//       </div>
//     </div>
//     </>
//   );
// };

// export default BannerOne;

import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./carouseledit.css";

const BannerOne = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/banner`);
        if (res.data && Array.isArray(res.data)) {
          const activeBanners = res.data.filter((b) => b.status);
          setBanners(activeBanners);
        }
      } catch (err) {
        console.error("Error fetching banners:", err);
      }
    };
    fetchBanner();
  }, []);

  return (
    <>
      <style>{`
        /* Responsive Banner Styling */
        .banner {
          width: 100%;
          padding: 0 15px;
        }

        .banner-item {
          height: 500px;
          border-radius: 24px;
          overflow: hidden;
          position: relative;
        }

        .banner-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .carousel-slide {
          height: 500px;
        }

        .scroll-down {
          width: 84px;
          height: 84px;
          font-size: 20px;
          bottom: 20px;
          transition: all 0.3s ease;
        }

        /* Tablet and below (991px and smaller) */
        @media (max-width: 991px) {
          .banner-item,
          .carousel-slide {
            height: 300px !important;
            border-radius: 16px !important;
          }

          .scroll-down {
            width: 60px !important;
            height: 60px !important;
            font-size: 18px !important;
            bottom: 15px !important;
          }

          .desktop-only {
            display: none !important;
          }
        }

        /* Mobile landscape (768px and smaller) */
        @media (max-width: 768px) {
          .banner-item,
          .carousel-slide {
            height: 280px !important;
          }

          .banner {
            padding: 0 10px;
          }
        }

        /* Mobile portrait (575px and smaller) */
        @media (max-width: 575px) {
          .banner-item,
          .carousel-slide {
            height: 220px !important;
            border-radius: 12px !important;
          }

          .scroll-down {
            width: 48px !important;
            height: 48px !important;
            font-size: 16px !important;
            bottom: 10px !important;
          }
        }

        /* Small mobile (400px and smaller) */
        @media (max-width: 400px) {
          .banner-item,
          .carousel-slide {
            height: 180px !important;
          }

          .banner {
            padding: 0 8px;
          }
        }

        /* Ensure carousel controls are visible and responsive */
        .carousel .control-arrow {
          opacity: 0.7;
        }

        .carousel .control-arrow:hover {
          opacity: 1;
        }

        @media (max-width: 575px) {
          .carousel .control-arrow {
            display: none;
          }
        }

        /* Carousel dots responsive */
        .carousel .control-dots {
          bottom: 10px;
        }

        @media (max-width: 575px) {
          .carousel .control-dots .dot {
            width: 6px;
            height: 6px;
            margin: 0 4px;
          }
        }
      `}</style>

      <div className="banner">
        <div className="container container-lg">
          <div className="banner-item">
            {/* Scroll Down Icon */}
            <a
              href="#flashSaleToday"
              className="desktop-only scroll-down text-center flex-center bg-main-600 rounded-circle border border-5 text-white border-white position-absolute start-50 translate-middle-x hover-bg-main-800"
              style={{ zIndex: 10 }}
            >
              <span className="icon line-height-0">
                <i className="ph ph-caret-double-down" />
              </span>
            </a>

            {banners.length > 0 ? (
              <Carousel
                autoFocus={true}
                showArrows={true}
                autoPlay={true}
                infiniteLoop={true}
                interval={4000}
                transitionTime={400}
                showStatus={false}
                showThumbs={false}
                swipeable={true}
                emulateTouch={true}
                dynamicHeight={false}
              >
                {banners.map((item, index) => (
                  <div key={index} className="carousel-slide">
                    <Link to={item.link} style={{ display: 'block', height: '100%' }}>
                      <img
                        src={item.banner}
                        alt={`Banner ${index + 1}`}
                        loading={index === 0 ? "eager" : "lazy"}
                      />
                    </Link>
                  </div>
                ))}
              </Carousel>
            ) : (
              <div style={{ 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                background: '#f5f5f5'
              }}>
                <p>Loading banners...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerOne;